import React from 'react';
import DesktopHeroArea from "../desktopHeroArea/DesktopHeroArea";
import MobileHeroArea from "../mobileHeroArea/MobileHeroArea";
import LandingSubHeroArea from "../landing/LandingSubHeroArea";
import {MDXRemote} from "next-mdx-remote";
import AdvertisementComponents from "../../constants/AdvertisementComponents";
import LandingLayout from "../../layouts/LandingLayout";

type IProps = {
    source: any
    frontMatter: any
}

const AdvertisementLayoutDesktopComp = (props: IProps) => {
    return (
        <React.Fragment>
            <LandingLayout
                heroArea={
                    <React.Fragment>
                        <DesktopHeroArea advertisement={props.frontMatter.formTitle}/>
                        <MobileHeroArea/>
                    </React.Fragment>
                }
                heroAreaBackgroundImage={'/next/assets/images/mobile-landing-hero-background.jpg'}
                heroAreaBackgroundImageDesktop={props.frontMatter.backgroundImageUrl ? props.frontMatter.backgroundImageUrl : '/next/images/landing/landing-reklam-hero-area-min.webp'}
                subHeroArea={
                    <React.Fragment>
                        <LandingSubHeroArea frontMatter={props.frontMatter}/>
                    </React.Fragment>
                }
            >
                <MDXRemote {...props.source} components={AdvertisementComponents}/>
            </LandingLayout>
        </React.Fragment>
    );
};

export default AdvertisementLayoutDesktopComp;
